import { render } from "./SignupPage.vue?vue&type=template&id=0ec16e9b&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"

import "./SignupPage.vue?vue&type=style&index=0&id=0ec16e9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec16e9b"]])

export default __exports__